export function modelChanged (currentModel, model) {
    if (JSON.stringify (model) !== JSON.stringify (currentModel)) {
        return true;
    }
    return false;
}

// export function getKey (event) {
//     let key = event.keyIdentifier;
//     if (!key) {
//         key = event.key;
//     }
//     key = key.toLowerCase();
//
//     let name;
//     switch (key) {
//     case "arrowup":
//         name = "up";
//         break;
//     case "arrowdown":
//         name = "down";
//         break;
//     case "arrowleft":
//         name = "left";
//         break;
//     case "arrowright":
//         name = "right";
//         break;
//     default:
//         name = key;
//     }
//
//     if (event.metaKey) {
//         // console.error("key:", event.metaKey, event);
//         name = `meta-${name}`;
//         if (name === "meta-meta") {
//             name = "meta";
//         }
//     }
//     return name;
// }
